import * as React from "react";

import { NidusEntry, NidusEntryData } from "../../../../../../Common/NidusClient/INidusClient";
import { DataDeclarationFactory, ValidationFunctionsFactory } from "../../../../Forms/RawFormResources";
import { DraftFullId } from "../../../../../../Common/CandyApiClient/Types/DraftFullId";
import { IContextualNidusClient } from "../../../../../../Common/NidusClient/ContextualNidusClient/IContextualNidusClient";
import { AutocalculationConfigurator } from "../../../../Forms/FormResources";

import { NidusEntryDataModalEditor } from "./NidusEntryDataModalEditor";

interface CreateNidusEntryFormModalProps {
    editor: React.ReactNode;
    editorValidations: ValidationFunctionsFactory;
    kcXmlValidationConfigurator: AutocalculationConfigurator;
    editorDataDeclaration: DataDeclarationFactory;
    title?: React.ReactNode;
    draftId: DraftFullId;
    keformsUrl: string;
    nidusClient: IContextualNidusClient;
    onItemCreated: (nidusEntry: NidusEntry) => void;
    onClose: () => void;
    onError: () => void;
}

export function CreateNidusEntryFormModal(props: CreateNidusEntryFormModalProps): JSX.Element {
    const handleApplyData = async (newEntryData: NidusEntryData) => {
        try {
            const newEntry = await props.nidusClient.insert(newEntryData);
            props.onItemCreated(newEntry);
        } catch {
            props.onError();
        }
    };

    return (
        <NidusEntryDataModalEditor
            editor={props.editor}
            editorValidations={props.editorValidations}
            kcXmlValidationConfigurator={props.kcXmlValidationConfigurator}
            editorDataDeclaration={props.editorDataDeclaration}
            title={props.title ?? "Новое значение для справочника"}
            initialData={{}}
            draftId={props.draftId}
            keformsUrl={props.keformsUrl}
            onApplyData={handleApplyData}
            onClose={props.onClose}
        />
    );
}
